import React from 'react';


const Attribution = (props) => { 


return (
      <a
        className="embed-attribution-overlay"
        href="https://aws.amazon.com/quick/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Powered by Amazon Quick"
      >
        <span className="qs-icon" aria-hidden="true">
          <svg
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#qs-clip)">
              <path
                d="M17.8235 4.14217L11.1749 0.31286C10.4496 -0.104287 9.55039 -0.104287 8.82507 0.31286L2.17493 4.14217C1.44961 4.55932 1 5.33737 1 6.17166V13.8287C1 14.663 1.44961 15.4411 2.17493 15.8582L8.82507 19.6875C9.18695 19.8953 9.59426 20 10 20C10.4057 20 10.8131 19.8953 11.1749 19.6875L17.8251 15.8582C18.5504 15.4411 19 14.663 19 13.8287V6.17166C19 5.33737 18.5504 4.55932 17.8251 4.14217H17.8235ZM17.4319 13.8287C17.4319 14.1068 17.2815 14.3662 17.0402 14.5052L10.3901 18.3345C10.1488 18.4736 9.84804 18.4736 9.60679 18.3345L2.95666 14.5052C2.7154 14.3662 2.56501 14.1068 2.56501 13.8287V12.8163L9.21514 8.98701V12.3648C9.21514 12.6445 9.36397 12.9023 9.60679 13.0413C9.84961 13.1804 10.1473 13.1804 10.3901 13.0413L17.4319 8.98701V13.8287ZM17.4319 7.18406L10.7817 11.0134V7.63558C10.7817 7.35592 10.6329 7.09813 10.3901 6.95909C10.1473 6.82004 9.84961 6.82004 9.60679 6.95909L2.56501 11.0134V6.17166C2.56501 5.89356 2.7154 5.63421 2.95666 5.49517L9.60836 1.66585C9.72898 1.59555 9.86527 1.56118 10 1.56118C10.1347 1.56118 10.271 1.59555 10.3916 1.66585L17.0418 5.49517C17.283 5.63421 17.4334 5.89356 17.4334 6.17166V7.18406H17.4319Z"
                fill="black"
              />
            </g>
            <defs>
              <clipPath id="qs-clip">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </span>

        <span className="attribution-text">Powered by Amazon Quick</span>
      </a>
)
};

export default Attribution;
